import { InverseHeader } from '@jouzen/ecom-components/layout';

import WhyOuraHeroOR4 from './HeroOR4';

const WhyOuraHero = () => {
  return (
    <InverseHeader enter>
      <div data-cy="why-oura-hero">
        <WhyOuraHeroOR4 />
      </div>
    </InverseHeader>
  );
};

export default WhyOuraHero;
